import {RootState} from '../../../testutils/configureStore'

export const getIsEmailSignInOpen = (state: RootState) =>
  state.emailSignUp?.isOpen

export const getEmailSignInSourceComponent = (state: RootState) =>
  state.emailSignUp?.sourceComponent

export const getEmailSignInFlow = (state: RootState) => state.emailSignUp?.flow

export const getEmailSignInAnalyticsData = (state: RootState) =>
  state.emailSignUp?.analyticsData
